import { h, render, Component } from 'preact'

export default class PlayerSearchBar extends Component {
  constructor(props) {
    super(props)

    this.state = {
      q: props.q
    }
    this.handleFilterTextInputChange = this.handleFilterTextInputChange.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this)
  }
  
  handleFilterTextInputChange(e) {
    this.setState({
      q: e.target.value
    })
    this.props.onFilterTextInput(e.target.value)
  }
  
  handleClearClick(e) {
    this.setState({
      q: void 0
    })
    this.props.onClearFilterText()
  }
  
  render(props, state) {
    return(
      <div class='player-search-bar'>
        <input type='text' class='input-search-bar' placeholder='Filter by name' onInput={ this.handleFilterTextInputChange } value={ this.state.q } />
        <span class='input-text-addon player-searchbar-button' onClick={ this.handleClearClick }>
          <i class='ss-icon ss-search-bar-clear u-icon-pos-fix'>&#x2421;</i>
        </span>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/player-search-bar-component.js